import { arrayOf, func, node, oneOfType, shape, string } from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';

import messageDescriptor from '../../lingui/LinguiPropTypes';
import useStyles from './MenuStyles';

const defaultPlacement = 'right';

export const actionsType = arrayOf(
    shape({
        id: string.isRequired,
        icon: node.isRequired,
        tooltip: oneOfType([string, messageDescriptor]),
        onClick: func.isRequired,
    })
);

export default function MenuActions({ actions }) {
    const classes = useStyles();

    function handleClick(event, callback) {
        event.preventDefault();
        event.stopPropagation();
        callback();
    }

    if (!actions) return null;
    return (
        <div className={classes.actions}>
            {actions.map((action) => {
                return (
                    <Tooltip
                        key={action.id}
                        title={action.tooltip}
                        placement={action.tooltipPlacement || defaultPlacement}
                    >
                        <IconButton disableRipple onClick={(event) => handleClick(event, action.onClick)}>
                            {action.icon}
                        </IconButton>
                    </Tooltip>
                );
            })}
        </div>
    );
}

MenuActions.propTypes = {
    actions: actionsType,
};

MenuActions.defaultProps = {
    actions: undefined,
};
